// Central config for the Nurhan & Emre wedding site
export const WEDDING = {
  couple: "Nurhan & Emre",
  firstName: "Nurhan",
  secondName: "Emre",
  // September 2026 is CEST (UTC+2)
  dateISO: "2026-09-04T18:00:00+02:00",
  endISO: "2026-09-05T01:00:00+02:00",
  whatsapp: "31647277384",
  venue: "Park de Heerlijkheid",
  address: "Herikweg 5, 3193 XA Hoogvliet Rotterdam",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Park%20de%20Heerlijkheid%2C%20Herikweg%205%2C%20Hoogvliet%20Rotterdam",
  mapsEmbedUrl:
    "https://www.google.com/maps?q=Park%20de%20Heerlijkheid%2C%20Herikweg%205%2C%20Hoogvliet%20Rotterdam&output=embed",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Raw .ics calendar content for the wedding
export function buildIcsContent() {
  const fmt = (iso) =>
    new Date(iso).toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//NurhanEmre//Wedding//NL",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${Date.now()}@nurhan-emre-wedding`,
    `DTSTAMP:${fmt(new Date().toISOString())}`,
    `DTSTART:${fmt(WEDDING.dateISO)}`,
    `DTEND:${fmt(WEDDING.endISO)}`,
    "SUMMARY:Bruiloft Nurhan & Emre",
    `LOCATION:${WEDDING.venue}\\, ${WEDDING.address}`,
    "DESCRIPTION:Wij gaan trouwen! / Evleniyoruz!",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
}

// Google Calendar "add event" link with the wedding prefilled
export function buildGoogleCalUrl() {
  const fmt = (iso) =>
    new Date(iso).toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: "Bruiloft Nurhan & Emre",
    dates: `${fmt(WEDDING.dateISO)}/${fmt(WEDDING.endISO)}`,
    details: "Wij gaan trouwen! / Evleniyoruz!",
    location: `${WEDDING.venue}, ${WEDDING.address}`,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export const IMAGES = {
  couple: "/couple.webp",
  park: "/venue/v-exterior.webp",
  iznik:
    "https://images.pexels.com/photos/34157465/pexels-photo-34157465.jpeg",
  // Real photos of Park de Heerlijkheid
  parkGallery: [
    "/venue/v-tables.jpg",
    "/venue/v-throne.jpg",
    "/venue/v-aisle.jpg",
  ],
};

